// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1ZmeJ","inner":"Footer_inner__Wmtwd","nextIcon":"Footer_nextIcon__vLMNZ","innerLeft":"Footer_innerLeft__AVpen"};